export enum CommonInsuranceNames {
  AETNA = 'Aetna',
  CIGNA = 'Cigna',
  KAISER = 'Kaiser Permanente',
  UNITED = 'United Healthcare',
  MEDICARE = 'Medicare'
}

export enum StateSpecificBCBSNames {
  CO = 'Anthem Colorado (or other Anthem/BCBS)',
  DC = 'CareFirst DC (or other BCBS)',
  MD = 'CareFirst Maryland (or other BCBS)',
  VA = 'CareFirst Virginia (or other BCBS)',
  GA = 'Anthem Georgia (or other Anthem/BCBS)',
  TX = 'BCBS Texas (or other BCBS)'
}

export const STATIC_STATE_INSURANCE_LISTS: Record<string, string[]> = {
  co: [
    CommonInsuranceNames.AETNA,
    StateSpecificBCBSNames.CO,
    CommonInsuranceNames.CIGNA,
    CommonInsuranceNames.KAISER,
    CommonInsuranceNames.UNITED
  ],
  dc: [
    CommonInsuranceNames.AETNA,
    StateSpecificBCBSNames.DC,
    CommonInsuranceNames.CIGNA,
    CommonInsuranceNames.KAISER,
    CommonInsuranceNames.UNITED
  ],
  md: [
    CommonInsuranceNames.AETNA,
    StateSpecificBCBSNames.MD,
    CommonInsuranceNames.CIGNA,
    CommonInsuranceNames.KAISER,
    CommonInsuranceNames.UNITED
  ],
  va: [
    CommonInsuranceNames.AETNA,
    StateSpecificBCBSNames.VA,
    CommonInsuranceNames.CIGNA,
    CommonInsuranceNames.KAISER,
    CommonInsuranceNames.UNITED
  ],
  ga: [
    CommonInsuranceNames.AETNA,
    StateSpecificBCBSNames.GA,
    CommonInsuranceNames.CIGNA,
    CommonInsuranceNames.KAISER,
    CommonInsuranceNames.UNITED
  ],
  tx: [
    CommonInsuranceNames.AETNA,
    StateSpecificBCBSNames.TX,
    CommonInsuranceNames.CIGNA,
    CommonInsuranceNames.MEDICARE,
    CommonInsuranceNames.UNITED
  ]
};
